import CreateDynamicFormFieldRequestModel from '../../generated/types/model/resource/CreateDynamicFormFieldRequestModel';

export default class CreateDynamicFormFieldRequestViewModel extends CreateDynamicFormFieldRequestModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
